import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportPortfolioNamesResultGridLayoutService } from '@irb/irb-clients/import-portfolio-names-result-dialog/import-portfolio-names-result.grid-layout.service';


@Component({ standalone: false,
  selector: 'irb-import-portfolio-names-result-dialog',
  templateUrl: './import-portfolio-names-result-dialog.component.html',
  styleUrls: ['./import-portfolio-names-result-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportPortfolioNamesResultDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportPortfolioNamesResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportPortfolioNamesResultGridLayoutService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbClientsEvents.IMPORT_PORTFOLIO_NAMES_COMPLETE, this.data);
    this.close();
  }
}
